import './scripts/common';
import {onFind} from '@elements/init-modules-in-scope';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as filter from "./scripts/filter.js";
filter.init();

import * as triggerSubmit from './scripts/trigger-submit';
triggerSubmit.init();

import * as eventCardTeaserSlider from './scripts/event-card-teaser-slider';
eventCardTeaserSlider.init();

import * as dynamicLightbox from './scripts/dynamic-lightbox';
dynamicLightbox.init();

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init();

import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as video from './scripts/video';
video.init();
